import React, { useCallback, useEffect, useRef, useState } from 'react'
import OutOfServiceAccordion from './OutOfServiceAccordion'
import { Box, Button, Grid, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material'
import SearchIcon from 'common/customIcons/search'
import { CloseRounded } from '@mui/icons-material'
import { useDebounce } from 'hooks/useDebounce'
import { ArrowDropDownIcon } from '@mui/x-date-pickers'
import HyperDriveMapDate from 'components/dateRangePicker/hyperDriveMapDate'
import { getDriverAnalyticsInfo } from '../../../../redux/slices/hyperdrive/driverAnalytics'
import moment from 'moment'
import { formatTimestampToMapOld } from 'utilities/common'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import NoDataFound from 'common/component/NoDataFound'
import Loader from 'common/Loader'
import { ThreeDot } from 'react-loading-indicators'

const OutofServiceDriver = ({ driverId }) => {
    const serviceData = []
    const [filterShow, setFilterShow] = useState(false)
    const dispatch = useDispatch()
    const today = new Date();
    const next = moment(today).add(1, 'day').toDate()
    const [dateRange, setDateRange] = useState([today, next]);
    const [startDate, endDate] = dateRange;
    const searchTermRef = useRef("")
    const fromDateRef = useRef('');
    const toDateRef = useRef('');
    const pageRef = useRef(0)
    fromDateRef.current = startDate ? formatTimestampToMapOld(startDate) : '';
    toDateRef.current = endDate ? formatTimestampToMapOld(endDate) : '';
    const { driverDetails, loading: loading = false } = useSelector(state => state?.driverAnalyticsHyperDrive)

    const applyHandler = () => {
        pageRef.current = 0;
        if (fromDateRef.current) {
            if (fromDateRef.current && toDateRef.current) {
                getOutofServiceData()
            }
            else {
                getOutofServiceData()
            }
        }
        else {
            getOutofServiceData()
        }
    }


    const clearAllHandler = () => {
        pageRef.current = 0;
        toDateRef.current = "";
        fromDateRef.current = "";
        setDateRange([null, null])
        getOutofServiceData()
    }

    const getOutofServiceData = () => {
        dispatch(getDriverAnalyticsInfo({
            driverId,
            data: {
                analyticType: "outOfService",
                skip: pageRef.current,
                limit: 20,
                from: fromDateRef.current ? fromDateRef.current : "",
                to: toDateRef.current ? toDateRef.current : "",
                // from: (fromDateRef.current && toDateRef.current) && fromDateRef.current ? fromDateRef.current : "",
                // to: (fromDateRef.current && toDateRef.current) && toDateRef.current ? toDateRef.current : "",
            }
        })).then((res) => {
        }).catch((err) => {
        });
    }
    useEffect(() => {
        getOutofServiceData()
    }, [])

    return (
        <Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" my={2}>
                <Typography variant='h4' className='text-20 text-white-700'>Out of Service</Typography>
                <Stack direction="row" justifyContent={{ xs: "start", sm: "end" }} flexWrap="wrap" alignItems="center" gap={1.5} className="hd-search-filter">

                    <Box className="filter-btns">
                        <Stack direction='row' alignItems="center" gap={1} className='w-100'>
                            <Button variant="outlined" color="primary"
                                className={filterShow ? "hd-filter-dropdown d-flex align-item-center gap-2 active-filter" : "hd-filter-dropdown d-flex align-item-center gap-2"}
                                onClick={() => setFilterShow(!filterShow)} >
                                <span>Filter</span>
                                <ArrowDropDownIcon />
                            </Button>
                        </Stack>
                    </Box>
                </Stack>
            </Box>
            {
                filterShow &&
                <Box className="cus-filter-sec" mb={1}>
                    <Grid className='filter-box' container alignItems="center" spacing={1.5}>
                        <Grid item xs={12} sm={12} md={12} xxl={12}>
                            <Box className="filter-price-unit">
                                <Stack direction='row' justifyContent='flex-end' width='100%' gap={2} >
                                    <Grid item xs={12} sm={12} md={12} xxl={12}>
                                        <Box display="flex" alignItems="center" justifyContent='flex-end' gap={2} className="w-100">
                                    
                                            <Box className="filter-pro-status hd-date-field dark-field dark-calendar">
                                                <Stack direction='row' alignItems="center">
                                                    <HyperDriveMapDate setDateRange={setDateRange} dateRange={dateRange} showIcon={false} />
                                                </Stack>
                                            </Box>
                                            <Box className="filter-btns">
                                                <Stack direction='row' alignItems="center" gap={1} className='w-100'>
                                                    <Button className="filter-clear-all" onClick={clearAllHandler} size="small" variant="text" color="secondary" style={{ width: "100px" }}>
                                                        Clear All
                                                    </Button>
                                                    <Button className="filter-apply" onClick={() => applyHandler()} size="small" variant="contained" color="primary" style={{ width: "120px" }}>
                                                        Apply
                                                    </Button>
                                                </Stack>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Stack>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            }
            {
                loading ?
                 <div className='loading-Spinner'>
                     <ThreeDot color='#3135cc'  size="medium" text="" textColor="" />
                 </div>
                 :
                    <div className='hd-tab-accordion'>
                        {driverDetails?.data?.totalOutOfService === 0 ?
                            <NoDataFound /> :
                            driverDetails?.data?.outOfService?.map((data) => {
                                const date = moment(data?.date).format("MMM DD, YYYY")

                                return (
                                    <OutOfServiceAccordion
                                        key={data?._id}
                                        day={date}
                                        servicedata={data?.data}
                                    // onEdit={(slot) => editHandler(data?._id)}
                                    // onDelete={(slot) => ActionDeleteHandler(slot, data?._id)}
                                    />
                                )
                            })
                        }
                    </div>
            }
        </Box>
    )
}

export default OutofServiceDriver
